<template>
    <header class="flex items-center justify-between px-4 md:px-6 py-3 bg-white dark:bg-[#060a12] border-b border-slate-200 dark:border-slate-800">
        <!-- The only way into the navigation below md. 44px square: the smallest
             target Apple and Android both consider reliably tappable. -->
        <button
            class="md:hidden w-11 h-11 -ml-2 flex items-center justify-center rounded-lg text-slate-500 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800"
            type="button"
            :aria-label="$t('nav.menu')"
            @click="toggleSidebar"
        >
            <i class="pi pi-bars text-lg" />
        </button>

        <div class="ml-auto flex items-center gap-3">
            <div class="flex items-center gap-2 pr-1">
                <div class="text-right leading-tight hidden sm:block">
                    <div class="text-sm font-medium dark:text-white">{{ appStore.userData?.name ?? '—' }}</div>
                    <div class="text-[10px] text-slate-400 capitalize">{{ appStore.userData?.role ?? '' }}</div>
                </div>
                <Button
                    v-tooltip.bottom="$t('profile.title')"
                    icon="pi pi-user"
                    severity="secondary"
                    size="small"
                    text
                    @click="profileDialog?.show()"
                />
                <Button
                    v-tooltip.bottom="$t('nav.logout')"
                    icon="pi pi-sign-out"
                    severity="secondary"
                    size="small"
                    text
                    @click="logout"
                />
            </div>

            <div class="w-px h-6 bg-slate-200 dark:bg-slate-700" />

            <LanguageSwitcher />

            <Button
                :icon="darkMode ? 'pi pi-moon' : 'pi pi-sun'"
                severity="secondary"
                size="small"
                text
                @click="toggleDarkMode"
            />
        </div>

        <ProfileDialog ref="profileDialog" />
    </header>
</template>

<script lang="ts" setup>
    import { Button } from 'primevue'
    import { useTemplateRef } from 'vue'
    import { useRouter } from 'vue-router'

    import LanguageSwitcher from '@/layouts/components/LanguageSwitcher.vue'
    import ProfileDialog from '@/layouts/components/ProfileDialog.vue'
    import { useLayout } from '@/layouts/layout'
    import { useAppStore } from '@/stores/app'

    const router   = useRouter()
    const appStore = useAppStore()

    const profileDialog = useTemplateRef<InstanceType<typeof ProfileDialog>>('profileDialog')

    const { darkMode, toggleDarkMode, toggleSidebar } = useLayout()

    const logout = () => {
        appStore.setLogout()
        router.push({ name: 'login' })
    }
</script>
